import { createRouter, createWebHistory } from 'vue-router';
import i18n from '@/i18n';
// eslint-disable-next-line
let locale = window.location.pathname.replace(/^\/([^\/]+).*/i, '$1') || process.env.VUE_APP_I18N_LOCALE;

const normalizeProductNames = () => {
  if (window.location.origin.includes('verbera')) {
    return { product: 'Verbera' };
  }

  if (window.location.origin.includes('anuncio')) {
    return { product: 'Anuncio' };
  }

  return { product: 'Verbera' };
};

const routes = [
  {
    path: '/:locale(.{2})?/',
    name: 'index',
    redirect: {
      name: 'Login'
    }
  },
  {
    path: '/:locale(.{2})?/auth',
    name: 'Auth',
    component: () => import('@/modules/auth/index.vue'),
    meta: {
      pageTitle: i18n.global.t('loginTitle', normalizeProductNames())
    },
    children: [
      {
        path: 'sign-in',
        name: 'Login',
        component: () => import('@/modules/auth/SignIn.vue'),
        meta: {
          pageTitle: i18n.global.t('signIn')
        }
      },
      {
        path: 'sign-up',
        name: 'Registration',
        component: () => import('@/modules/auth/SingUp.vue'),
        meta: {
          pageTitle: i18n.global.t('signUp')
        }
      }
    ]
  },
  {
    path: '/:locale(.{2})?/open',
    name: 'AuthByLink',
    component: () => import('@/modules/auth/AuthByLink.vue'),
    meta: {
      pageTitle: i18n.global.t('loginTitle', normalizeProductNames())
    }
  },
  {
    path: '/:locale(.{2})?/privacy-policy',
    name: 'PrivacyPolicy',
    component: () => import('@/modules/text-pages/privacy-policy/index.vue'),
    meta: {
      pageTitle: i18n.global.t('privacyPolicy')
    }
  },
  {
    path: '/:locale(.{2})?/terms-of-use',
    name: 'TermsOfUse',
    component: () => import('@/modules/text-pages/terms-of-use/index.vue'),
    meta: {
      pageTitle: i18n.global.t('termsAndConditions')
    }
  },
  {
    path: '/:locale(.{2})?/data-processing-agreement',
    name: 'DataProcessingAgreement',
    component: () => import('@/modules/text-pages/agreement/index.vue'),
    meta: {
      pageTitle: i18n.global.t('dataProcessingAgreement')
    }
  },
  {
    path: '/:locale(.{2})?/unsubscribe',
    name: 'Unsubscribe',
    component: () => import('@/modules/system/Unsubscribe.vue'),
    meta: {
      pageTitle: i18n.global.t('unsubscribe')
    }
  },
  {
    path: '/:locale(.{2})?/profiles/:profileId?',
    component: () => import('@/modules/main/index.vue'),
    children: [
      {
        path: 'all',
        name: 'Profiles',
        component: () => import('@/modules/profiles/index.vue'),
        meta: {
          pageTitle: i18n.global.t('allProfiles')
        }
      },
      {
        path: 'license',
        name: 'License',
        component: () => import('@/modules/license/index.vue'),
        meta: {
          pageTitle: i18n.global.t('license')
        }
      },
      {
        path: 'connections',
        name: 'Connections',
        component: () => import('@/modules/connections/index.vue'),
        meta: {
          pageTitle: i18n.global.t('connections')
        }
      },
      {
        path: 'personnel',
        name: 'Personnel',
        component: () => import('@/modules/users/index.vue'),
        meta: {
          pageTitle: i18n.global.t('users')
        }
      },
      {
        path: 'message-templates/:groupId/messages',
        name: 'MessageTemplates',
        component: () => import('@/modules/message-templates/Messages.vue'),
        meta: {
          pageTitle: i18n.global.t('messageTemplates')
        }
      },
      {
        path: 'message-templates',
        name: 'MessageGroups',
        component: () => import('@/modules/message-templates/Groups.vue'),
        meta: {
          pageTitle: i18n.global.t('messageGroups')
        }
      },
      {
        path: 'group-contacts',
        name: 'GroupContacts',
        component: () => import('@/modules/contact-templates/Groups.vue'),
        meta: {
          pageTitle: i18n.global.t('contactGroups')
        }
      },
      {
        path: 'groups/:groupId/contacts',
        name: 'Contacts',
        component: () => import('@/modules/contact-templates/Contacts.vue'),
        meta: {
          pageTitle: i18n.global.t('contactTemplates')
        }
      },
      {
        path: 'groups/:groupId/contacts-import',
        name: 'ContactsImport',
        component: () => import('@/modules/contact-templates/Import.vue'),
        meta: {
          pageTitle: i18n.global.t('contactImport')
        }
      },
      {
        path: 'campaigns-send',
        name: 'BulkSends',
        component: () => import('@/modules/send-campaign/index.vue'),
        meta: {
          pageTitle: i18n.global.t('sendCampaign')
        }
      },
      {
        path: 'campaign-send/:id?',
        name: 'BulkSend',
        component: () => import('@/modules/send-campaign/Detail.vue'),
        meta: {
          pageTitle: i18n.global.t('sendCampaign')
        }
      },
      {
        path: 'order-history',
        name: 'OrderHistory',
        component: () => import('@/modules/order-history/index.vue'),
        meta: {
          pageTitle: i18n.global.t('orderHistory')
        }
      },
      {
        path: 'statistic',
        name: 'Statistic',
        component: () => import('@/modules/statistic/index.vue'),
        meta: {
          pageTitle: i18n.global.t('statistic')
        }
      },
      {
        path: 'connections/list',
        name: 'BotConnections',
        component: () => import('@/modules/crm-chat/BotConnections.vue'),
        meta: {
          pageTitle: i18n.global.t('bots')
        }
      },
      {
        path: 'connections/list/:connectionId',
        name: 'BotConnectionItem',
        component: () => import('@/modules/crm-chat/ChatLayout.vue'),
        meta: {
          pageTitle: i18n.global.t('departmentLabel')
        },
        children: [
          {
            path: 'chat/:chatId',
            name: 'SupportChat',
            component: () => import('@/modules/crm-chat/ChatLayout.vue'),
            meta: {
              pageTitle: i18n.global.t('chatsDepartment')
            }
          }
        ]
      }
    ]
  }
];
const router = createRouter({
  base: locale.trim().length && locale !== '/' ? '/' + locale : process.env.VUE_APP_I18N_LOCALE,
  history: createWebHistory(process.env.BASE_URL),
  mode: 'history',
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { left: 0, top: 0 };
    }
  },
  routes
});

const availableLocales = process.env.VUE_APP_I18N_SUPPORTED_LOCALE;
router.beforeEach((to, from, next) => {
  if (availableLocales.includes(to.params.locale)) {
    next();
  } else {
    next({
      name: to.name,
      params: { locale: process.env.VUE_APP_I18N_LOCALE },
      query: to.query
    });
  }
});

export default router;
